import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import moment from "moment";

export const initialClientLocalState = {
  role: "TENANT",
  tenantId: "",
  companyProfile: {
    logo: "",
    clientName: "",
    companyName: "",
    registrationDate: "",
    phoneNumber: "",
    address: "",
    postCode: "",
    companyStrapLine: "",
    vatPercent: "",
    vatRegNo: "",
    dateFormat: "",
    timezone: "Europe/London",
    companyRegNo: "",
    generalWebsite: "",
  },
  subscription: {
    planId: "",
    duration: "",
    startDate: "",
    endDate: "",
    term: "",
    renewsOn: "",
    subscriptionCost: "",
    discount: "",
    amountPayable: "",
    paymentMethod: "",
    status: "",
  },
  financialInformation: {
    isSameWithCompanyAddress: false,
    invoiceAddress: "",
    paymentTerms: "",
    bankSortCode: "",
    bankAccountNumber: "",
    accountHolderName: "",
    IBAN: "",
    swiftNumber: "",
    bankName: "",
    extendedLiabilityPercent: "",
    extendedLiabilityTax: "",
    insuranceFixedRate: "",
  },
  emailSetting: {
    email: "",
    notificationEmail: "",
    // emailPassword: "",
    emailSignature: "",
    emailDisclaimer: "",
  },
};

const initialState = {
  clients: [],
  clientPagination: {},
  clientDetails: null,
  isClientToggleResponse: false,
  isClientToggleError: false,
  isClientSuspensionResponse: false,
  isClientSuspensionError: false,
  isClientResetPasswordError: false,
  isClientResetPasswordSuccess: false,
  isClientDeleteError: false,
  isClientDeleteSuccess: false,
  clientDeleteError: null,
  clientActivityResponse: null,
  newClientLocal: initialClientLocalState,
  isUniqueCompanyNameError: false,
  isUniqueVatError: false,
  isEmailError: false,
  isAddClientSuccess: false,
  isClientEditSuccess: false,
  isAdminUpdateSuccess: false,
  isAdminUpdateError: false,
  editClientOriginalData: {}
};

export const adminClientsSlice = createSlice({
  name: "AdminClients",
  initialState,
  reducers: {
    getAllTelnetAction: (state, { payload }) => {},

    setAllTelnetAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.clients = list;
      // if (pagination.currentPage === 1) {
      //     state.clients = data;
      //   } else {
      //     const newClients = state.clients;
      //     newClients.push(...data);
      //     state.clients = newClients;
      //   }
      state.clientPagination = pagination;
    },

    setNewClientLocal: (state, action) => {
      state.newClientLocal = {
        ...state.newClientLocal,
        ...action.payload,
      };
    },
    resetNewClientLocal: (state) => {
      state.newClientLocal = initialClientLocalState;
    },

    addTelnetAction: (state, { payload }) => {},
    setAddTelnetAction: (state, { payload }) => {
        state.isAddClientSuccess = payload
    },
    setAddTelnetIdAction: (state, { payload }) => {
      state.newClientLocal = {
        ...state.newClientLocal,
        ...{tenantId: payload},
      };
    },

    updateTelnetAction: (state, { payload }) => {},
    setAdminSuccessAction: (state, { payload }) => {
      state.isAdminUpdateSuccess = payload
    },
    setAdminErrorAction: (state, { payload }) =>{
      state.isAdminUpdateError = payload
    },

    updateTelnetSubscriptionAction: (state, { payload }) => {},

    getSingleTelnetAction: (state, { payload }) => {},
    setSingleTelnetAction: (state, { payload }) => {
      state.clientDetails = payload;
    },

    getActivationToggleAction: (state, { payload }) => {},
    setActivationToggleAction: (state, { payload }) => {
      state.isClientToggleResponse = payload;
    },

    setActivationToggleErrorAction: (state, { payload }) => {
      state.isClientToggleError = payload;
    },

    getSuspensionToggleAction: (state, { payload }) => {},
    setSuspensionToggleAction: (state, { payload }) => {
      state.isClientSuspensionResponse = payload;
    },

    setSuspensionToggleErrorAction: (state, { payload }) => {
      state.isClientSuspensionError = payload;
    },

    getResetPasswordAction: (state, { payload }) => {},
    setResetPasswordAction: (state, { payload }) => {
      console.log("payload", payload);
      state.isClientResetPasswordError = payload;
    },
    setResetPasswordSuccessAction: (state, { payload }) => {
      state.isClientResetPasswordSuccess = payload;
    },

    getDeleteTelnetAction: (state, { payload }) => {},
    setDeleteTelnetAction: (state, { payload }) => {
      state.isClientDeleteError = payload;
    },
    setDeleteTelnetSuccessAction: (state, { payload }) => {
      state.isClientDeleteSuccess = payload;
    },

    getTelnetActivityAction: (state, { payload }) => {},
    setTelnetActivityAction: (state, { payload }) => {
      state.clientActivityResponse = payload;
    },

    getCheckUniqueEmailAction: (state, { payload }) => {},
    setCheckUniqueEmailAction: (state, { payload }) => {
      state.isEmailError = payload
    },

    getCheckUniqueVatAction: (state, { payload }) => {},
    setCheckUniqueVatAction: (state, { payload }) => {
      state.isUniqueVatError = payload
    },

    getCheckUniqueCompanyNameAction: (state, { payload }) => {},
    setCheckUniqueCompanyNameAction: (state, { payload }) => {
      state.isUniqueCompanyNameError = payload
    },

    getClientForEditAction: (state) => {},
    setClientForEditAction: (state, { payload }) => {
      state.editClientOriginalData = payload;
      const data: any = {
        ...{tenantId: payload?.tenant_id || ""},
        ...{companyProfile: {
          // logo: payload?.logo || "",
          clientName: payload?.client_name || "",
          companyName: payload?.company_name || "",
          registrationDate: payload?.registration_date || "",
          phoneNumber: payload?.phone_number || "",
          address: payload?.address || "",
          postCode: payload?.post_code || "",
          transportCode: payload?.transport_code || "",
          correspondingAddress: payload?.corresponding_address || "",
          correspondingPostCode: payload?.corresponding_post_code || "",
          companyStrapLine: payload?.company_strap_line || "",
          vatPercent: parseInt(payload?.vat_percent) || "",
          vatRegNo: payload?.vat_reg_no || "",
          dateFormat: payload?.date_format || "MM/DD/YYYY",
          timezone: payload?.timezone || "Europe/London",
          companyRegNo: payload?.company_reg_no || "",
          generalWebsite: payload?.general_website || "",
        }},
        ...{financialInformation: {
          isSameWithCompanyAddress: payload?.is_same_with_company_address || false,
          invoiceAddress: payload?.invoice_address || "",
          paymentTerms: payload?.payment_terms || "",
          bankSortCode: payload?.bank_sort_code || "",
          bankAccountNumber: payload?.bank_account_no || "",
          accountHolderName: payload?.account_holder_name || "",
          IBAN: payload?.iban || "",
          swiftNumber: payload?.swift_no || "",
          bankName: payload?.bank_name || "",
          extendedLiabilityPercent: parseInt(payload?.extended_liability_percent) || "",
          extendedLiabilityTax: parseInt(payload?.extended_liability_tax) || "",
          insuranceFixedRate: parseInt(payload?.insurance_fixed_rate) || "",
          invoiceDueDays: payload?.invoice_due_days || "",
          depositPaymentPercent: parseInt(payload?.deposit_payment_percent) || "",
        }},
        ...{emailSetting: {
          email: payload?.email || "",
          notificationEmail: payload?.notification_email || "",
          accountsEmail: payload?.accounts_email || "",
          // emailPassword: payload?.email_password || "",
          emailSignature: payload?.email_signature || "",
          emailDisclaimer: payload?.email_disclaimer || "",
        }}
      };
      state.newClientLocal = data
    },
    putEditClientAction: (state, { payload }) => {},
    setEditClientAction: (state, { payload }) => {
      state.isClientEditSuccess = payload;
    },

    getPlanClientAction: (state, { payload }) => {},
    setPlanClientAction: (state, { payload }) => {
      const data: any = {
        ...{tenantId: payload?.tenant_id || state?.newClientLocal?.tenantId || ""},
        ...{subscription: {
          tenantId: payload?.tenant_id || "",
          planId: payload?.plan_id || "",
          duration: payload?.duration || "",
          startDate: payload?.start_date ? moment(payload?.start_date).format("MM/DD/YYYY") : "",
          endDate: payload?.end_date ? moment(payload?.end_date).format("MM/DD/YYYY") : "",
          term: (payload?.start_date && payload?.end_date) ? [payload?.start_date, payload?.end_date] :  "",
          renewsOn: payload?.end_date ? (dayjs(payload?.end_date).add(1, "day")).format("MM/DD/YYYY") : "",
          subscriptionCost: payload?.cost || "",
          discount: payload?.discount || "",
          amountPayable: payload?.amount_payable || "",
          paymentMethod: payload?.payment_method || "",
          status: payload?.status || "",
        }}
      };
      state.newClientLocal = data
    }
  },
});

const {
  getAllTelnetAction,
  setAllTelnetAction,
  setNewClientLocal,
  resetNewClientLocal,
  addTelnetAction,
  setAddTelnetAction,
  setAddTelnetIdAction,
  updateTelnetAction,
  setAdminSuccessAction,
setAdminErrorAction,
  updateTelnetSubscriptionAction,
  getSingleTelnetAction,
  setSingleTelnetAction,
  getActivationToggleAction,
  setActivationToggleAction,
  setActivationToggleErrorAction,
  getSuspensionToggleAction,
  setSuspensionToggleAction,
  setSuspensionToggleErrorAction,
  getResetPasswordAction,
  setResetPasswordAction,
  setResetPasswordSuccessAction,
  getDeleteTelnetAction,
  setDeleteTelnetAction,
  setDeleteTelnetSuccessAction,
  getTelnetActivityAction,
  setTelnetActivityAction,
  getCheckUniqueEmailAction,
  getCheckUniqueVatAction,
  getCheckUniqueCompanyNameAction,
  setCheckUniqueCompanyNameAction,
  setCheckUniqueVatAction,
  setCheckUniqueEmailAction,
  getClientForEditAction,
  setClientForEditAction,
  putEditClientAction,
  setEditClientAction,
  getPlanClientAction,
  setPlanClientAction
} = adminClientsSlice.actions;

export {
  getAllTelnetAction,
  setAllTelnetAction,
  setNewClientLocal,
  resetNewClientLocal,
  addTelnetAction,
  setAddTelnetAction,
  setAddTelnetIdAction,
  updateTelnetSubscriptionAction,
  updateTelnetAction,
  setAdminSuccessAction,
  setAdminErrorAction,
  getSingleTelnetAction,
  setSingleTelnetAction,
  getActivationToggleAction,
  setActivationToggleAction,
  setActivationToggleErrorAction,
  getSuspensionToggleAction,
  setSuspensionToggleAction,
  setSuspensionToggleErrorAction,
  getResetPasswordAction,
  setResetPasswordAction,
  setResetPasswordSuccessAction,
  getDeleteTelnetAction,
  setDeleteTelnetSuccessAction,
  setDeleteTelnetAction,
  getTelnetActivityAction,
  setTelnetActivityAction,
  getCheckUniqueEmailAction,
  getCheckUniqueVatAction,
  getCheckUniqueCompanyNameAction,
  setCheckUniqueCompanyNameAction,
  setCheckUniqueVatAction,
  setCheckUniqueEmailAction,
  getClientForEditAction,
  setClientForEditAction,
  putEditClientAction,
  setEditClientAction,
  getPlanClientAction,
  setPlanClientAction
};

export default adminClientsSlice.reducer;
